declare var swal: any;
import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
//import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ApiRequestModel } from '../../../../models/api_request_model';
import { SpinnerService } from '../../../../services/spinner.service';
import { AppData } from '../../../../models/appdata';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DOCService } from '../../../../services/doc.service';
import { DownloadFileRequest } from '../../../../models/docs/doc.model';
import { ActorIdentitiesRequest, ActorDocRequest, ActorDocController, SaveCounsellingPlanRequest, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, PurchaseIndentsListController, PurchaseIndentsListRequest } from '../../../../models/actor/actor';
import { ActorService } from '../../../../services/actor.service';
import { DBOperation } from '../../../../enums/enum';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { NGXToastrService } from '../../../../../shared/services/toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'searchpurchaseindents',
  templateUrl: './searchpurchaseindents.modal.html',
  styleUrls: ['./searchpurchaseindents.modal.scss']
})

export class NgbSearchPurchaseIndentsModal implements OnInit {

  @Input() public FromScreen: string;
  SelectedFromDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  minDate: NgbDateStruct;
  public searchValue: any;
  public isRequesting: boolean = false;
  public ApiResData: ApiResponseModel;
  public ApiReqData: ApiRequestModel
  private modalRef: NgbModalRef;
  TodayDate = new Date();

  CurrentPurchaseIndentsListController: PurchaseIndentsListController[];
  CurrentPurchaseIndentsHeaderController: PurchaseIndentsListController[];
  CurrentPurchaseIndentsListRequest: PurchaseIndentsListRequest;

  LoadIndents() {
    this.CurrentPurchaseIndentsListRequest = new PurchaseIndentsListRequest();
    this.CurrentPurchaseIndentsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    //this.pdata = this.CurrentPurchaseIndentsListController;
    this.GetPurchaseIndentsListController();
  }
  GetPurchaseIndentsListController() {
    this.StartRefreshing();
    this.CurrentPurchaseIndentsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentPurchaseIndentsListRequest.FromDate = new Date();
    this.CurrentPurchaseIndentsListRequest.ToDate = new Date();
    //this.CurrentPurchaseIndentsListRequest.PurchaseIndentCode = 0;
    this.CurrentPurchaseIndentsListRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseIndentsListController(this.CurrentPurchaseIndentsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentPurchaseIndentsListController = this.ApiResData.Result;
          //this.pdata = this.CurrentPurchaseIndentsListControllernew;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  dataChanged(newobj) {

    this._GetPurchaseIndentsListController()
  }
  _GetPurchaseIndentsListController() {
    this.StartRefreshing();
    this.CurrentPurchaseIndentsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentPurchaseIndentsListRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentPurchaseIndentsListRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    //this.CurrentPurchaseIndentsListRequest.PurchaseIndentCode = 0;
    this.CurrentPurchaseIndentsListRequest.ConditionalOperator = 10;
    this.actorservice.GetPurchaseIndentsListController(this.CurrentPurchaseIndentsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentPurchaseIndentsListController = this.ApiResData.Result;
          //this.pdata = this.CurrentPurchaseIndentsListControllernew;
          this.stopRefreshing();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  DecrementDate() {

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetPurchaseIndentsListController();
  }
  IncrementDate() {

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetPurchaseIndentsListController();
  }

  @ViewChild('f') IdentitiesDocForm: NgForm;
  public UploadActorDoc: any;

  public CanDownLoadActorDoc: number

  public CanNurseView: number = 0;



  constructor(public activeModal: NgbActiveModal, private loaderService: SpinnerService, private docservice: DOCService,
    private router: Router, private route: ActivatedRoute, private spinner: NgxSpinnerService, private actorservice: ActorService, private tosterservice: NGXToastrService, private parserFormatter: NgbDateParserFormatter) { }
  ngOnInit() {

    this.LoadIndents();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };

  }
  //SelectedOrder(DocID: string) {
  //  this.router.navigate(['healins/purchaseorderadd', { DocIDdata: DocID }]);
  //  this.activeModal.close();
  //}
  SelectedOrder(DocID: string) {
    this.router.navigate(['healins/purchaseorderadd_disc', { DocIDdata: DocID}]);
      this.activeModal.close();
  }
  SelectedOrder2(DocID: string) {
    this.router.navigate(['healins/poviadd', { DocIDdata: DocID }]);
    this.activeModal.close();
  }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}

